// extracted by mini-css-extract-plugin
export default {"s_download":"Download_s_download__IuCxQ","div_disable":"Download_div_disable__MTfhO","div_enable":"Download_div_enable__ac3g4"};